import classNames from "classnames";
import { ReactNode } from "react";

export interface HeaderProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  badge?: ReactNode;
  actions?: ReactNode;
  metadata?: ReactNode;
  variant?: "page" | "section" | "card";
  density?: "comfortable" | "compact";
  className?: string;
}

export const Header = ({
  title,
  description,
  icon,
  badge,
  actions,
  metadata,
  variant = "page",
  density = "comfortable",
  className,
}: HeaderProps) => {
  const isPage = variant === "page";
  const isCompact = density === "compact";

  return (
    <div className={classNames("flex flex-col gap-4 md:flex-row md:items-start md:justify-between font-sans", className)}>
      <div className="flex min-w-0 flex-1 items-start gap-4">
        {icon && (
          <div className={classNames(
            "flex items-center justify-center shrink-0 rounded-xl bg-primary-50/50 text-primary-600 border border-primary-200/50 dark:bg-content-800/50 dark:text-primary-400 dark:border-primary-800/50",
            isPage ? "h-12 w-12 text-xl" : "h-10 w-10 text-lg"
          )}>
            {icon}
          </div>
        )}
        <div className="flex min-w-0 flex-col gap-1">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className={classNames(
              "font-header font-medium text-content-900 dark:text-content-100 my-2 min-w-0 leading-tight",
              isPage ? (isCompact ? "text-xl" : "text-2xl md:text-3xl") : "text-lg md:text-xl"
            )}>
              {title}
            </h2>
            {badge && <div>{badge}</div>}
          </div>
          {description && (
            <p className={classNames(
              "text-content-600 dark:text-content-400 max-w-2xl leading-tight my-2",
              isCompact ? "text-sm" : "text-base"
            )}>
              {description}
            </p>
          )}
          {metadata && (
            <div className="mt-1 flex flex-wrap items-center gap-3 text-sm text-content-500 dark:text-content-400">
              {metadata}
            </div>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex items-center gap-2 shrink-0 self-start">
          {actions}
        </div>
      )}
    </div>
  );
};
